export default __webpack_public_path__ + "static/RollingStone-bcad472faeb5bb39ccdb10c498fd1ca8.svg";